import Vue from 'vue'
import Buefy from 'buefy'

import '@mdi/font/css/materialdesignicons.css'
import '@/assets/scss/main.scss'

Vue.use(Buefy)
